/* eslint-disable react-hooks/exhaustive-deps */
import {logging} from "@/utils/functions";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import WestOutlinedIcon from '@mui/icons-material/WestOutlined';
import {
    Box,
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    Stack,
    Typography
} from "@mui/material";
import {blue, grey} from "@mui/material/colors";
import _ from "lodash";
import React, {useEffect, useMemo, useRef, useState} from "react";
import Utils from "@/components/Shared/Utils";

import TextField from "@mui/material/TextField";

import {resolveCustomerServices} from "@/services/services.ts";
import {Service} from "@/types/utils.ts";

import {Controller, useForm} from "react-hook-form";
import {LoadingDotBox} from "@/components/Shared/LoadingBox.tsx";
import {resolveCustomerTeamMember} from "@/services/customer.ts";
import {createTeammate} from "@/services/team.ts";

const selectInputProps = {
    sx: {
        fontSize: 12,
    },
}

export default function OrganizationTeamInvitation({team, refetchTeamOverview, close}: any) {
    const input = useRef<any>(null);

    const {data} = resolveCustomerServices();
    const services = useMemo(() => data?.data?.services?.map((service) => ({
        service_id: service.service_id,
        service_name: service.service_name
    })) || [], [data]);
    const {refetch: refetchTeamMembersList} = resolveCustomerTeamMember(team);

    const [members, setMembers] = useState<string[]>([]);
    const [payload, setPayload] = useState<any>(null);
    const all: any = useMemo(() => ([{service_id: '-', service_name: 'All'}]), [services])

    const resources = useMemo(() => [
        {
            name: 'Service',
            value: 'service',
            disabled: false
        },
        {
            name: 'Account',
            value: 'account',
            disabled: true
        }
    ], [team]);

    const {control, watch, setValue, handleSubmit} = useForm();

    function handleSubmitMembers() {
        let items: string[] = [];
        const target = input.current?.querySelector("input");

        items = target?.value === "" ? [] : target?.value?.toString().split(",") || [];
        setMembers(_.uniq([...members, ...items]));

        target.value = "";
        target.focus();
    }

    function handleRemoveMember(string: string) {
        const items = members.filter((item: any) => item !== string);

        setMembers(items);
    }

    async function handleScopePreview(data: any) {
        const payload = {
            members,
            shares: data
        }

        logging("OrganizationTeamInvitation ▶ ScopePreview", payload);

        refetchTeamOverview()
        await refetchTeamMembersList()

        setPayload(payload)
    }

    async function handleSubmitTeammateInvitation({
                                                      operator,
                                                      share_referrer_objects,
                                                      share_referrer_type,
                                                      ...data
                                                  }: any) {
        logging("OrganizationTeamInvitation ▶ Referrer", share_referrer_type);

        const permissions = Object.entries(data).map((item: any) => {
            let [id, roles] = item;

            id = Number(id)
            roles = _.omit(roles, _.filter(_.keys(roles), (key) => _.isUndefined(roles[key]) || !roles[key]))

            logging(`OrganizationTeamInvitation ▶ ${share_referrer_type}`, id);
            logging("OrganizationTeamInvitation ▶ Roles", roles);

            return _.keys(roles)?.map((action: string) => `${share_referrer_type}:${id}:${action}`)

            // return ({
            //     id: Number(id),
            //     roles: 
            // })
        }).flat()

        const payload = {
            members,
            share: {
                operator,
                share_referrer_objects,
                share_referrer_type,
                permissions
            }
        }

        logging("OrganizationTeamInvitation ▶ Payload", payload);
        const result = await createTeammate(payload, team.owner)

        // console.log(result)

        if (result) {
            await refetchTeamMembersList()
            refetchTeamOverview()
            close()
        }
    }

    useEffect(() => {
        logging("OrganizationTeamInvitation ▶ Team", team);
    }, []);

    return (
        <Utils.LayoutUtils.MainAttachedSidebar>
            <Box sx={{height: 50, p: 1, borderBottom: `1px solid ${grey[100]}`}}>
                <Button variant="text" sx={{fontSize: 13, fontWeight: 500, mr: 1}}>
                    Team Invitation
                </Button>
            </Box>
            <Box sx={{
                p: 2,
                height: 'calc(100vh - 100px)'
            }}>
                {payload ? (
                    <>
                        <Box sx={{mb: 3}}>
                            <Button
                                disabled={!team} onClick={() => setPayload(null)}
                                variant="text"
                                startIcon={<WestOutlinedIcon/>}
                                sx={{fontSize: 13}}
                            >
                                Edit
                            </Button>
                        </Box>
                        <Box sx={{mb: 2}}>
                            <Typography fontSize={13} fontWeight={700}>
                                Permissions
                            </Typography>
                            <Typography fontSize={13}>
                                Select permissions that apply to <b
                                style={{color: blue[900]}}>{payload.shares?.operator}</b> {payload.shares?.share_referrer_type}(s): {payload.shares?.share_referrer_objects?.map((id: number, index: number) => (
                                <span key={id}>
                                    <b style={{color: blue[900]}}>{id}</b>
                                    {(index !== payload.shares?.share_referrer_objects?.length - 1) && `, `}
                                </span>
                            ))}.
                            </Typography>
                        </Box>
                        <Box sx={{mb: 2, bgcolor: grey[100], p: 2, borderRadius: 1}}>
                            {members.map((email: string) => {
                                const items = all.concat(services).filter((item: any) => payload.shares?.share_referrer_objects.includes(item.service_id))

                                return (
                                    <Box key={email}>
                                        <Typography fontSize={13} fontWeight={700}>{email}</Typography>
                                        <Box sx={{mt: 1, pl: 3}}>
                                            <Typography fontSize={13} fontWeight={700}
                                                        textTransform="capitalize">[] {payload.shares?.share_referrer_type}</Typography>
                                            <Box sx={{mb: -1, mt: 1, pl: 3}}>
                                                {items?.map((item: any) => {
                                                    return (
                                                        <Box sx={{mb: 1}} key={item.service_id}>
                                                            <Typography fontSize={13} fontWeight={700}
                                                                        color={blue[900]}>- {item.service_name}</Typography>
                                                            <Box sx={{mt: 1, pl: 3}}>
                                                                <Box>
                                                                    <Controller
                                                                        control={control}
                                                                        name={`${item.service_id}.all`}
                                                                        defaultValue={true}
                                                                        render={({field: {onChange, ...field}}) => (
                                                                            <FormControlLabel
                                                                                control={<Checkbox size="small"
                                                                                                   defaultChecked {...field}
                                                                                                   onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                                                       const checked = event.target.checked;

                                                                                                       setValue(`${item.service_id}.list`, true)
                                                                                                       setValue(`${item.service_id}.show`, true)
                                                                                                       setValue(`${item.service_id}.create`, true)
                                                                                                       setValue(`${item.service_id}.edit`, true)

                                                                                                       onChange(checked)
                                                                                                   }}/>}
                                                                                componentsProps={{typography: {fontSize: 14}}}
                                                                                label={
                                                                                    <Typography
                                                                                        sx={{fontSize: 13}}>All</Typography>
                                                                                }
                                                                            />
                                                                        )}
                                                                    />
                                                                </Box>
                                                                {!watch(`${item.service_id}.all`, true) && (
                                                                    <>
                                                                        <Controller
                                                                            control={control}
                                                                            name={`${item.service_id}.list`}
                                                                            defaultValue={true}
                                                                            render={({field}) => (
                                                                                <FormControlLabel
                                                                                    control={<Checkbox
                                                                                        defaultChecked
                                                                                        size="small" {...field} />}
                                                                                    componentsProps={{typography: {fontSize: 14}}}
                                                                                    label={
                                                                                        <Typography
                                                                                            sx={{fontSize: 13}}>List</Typography>
                                                                                    }
                                                                                />
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`${item.service_id}.show`}
                                                                            defaultValue={true}
                                                                            render={({field}) => (
                                                                                <FormControlLabel
                                                                                    control={<Checkbox
                                                                                        defaultChecked
                                                                                        size="small" {...field} />}
                                                                                    componentsProps={{typography: {fontSize: 14}}}
                                                                                    label={
                                                                                        <Typography
                                                                                            sx={{fontSize: 13}}>Show</Typography>
                                                                                    }
                                                                                />
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`${item.service_id}.create`}
                                                                            defaultValue={true}
                                                                            render={({field}) => (
                                                                                <FormControlLabel
                                                                                    control={<Checkbox
                                                                                        defaultChecked
                                                                                        size="small" {...field} />}
                                                                                    componentsProps={{typography: {fontSize: 14}}}
                                                                                    label={
                                                                                        <Typography
                                                                                            sx={{fontSize: 13}}>Create</Typography>
                                                                                    }
                                                                                />
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`${item.service_id}.edit`}
                                                                            defaultValue={true}
                                                                            render={({field}) => (
                                                                                <FormControlLabel
                                                                                    control={<Checkbox
                                                                                        defaultChecked
                                                                                        size="small" {...field} />}
                                                                                    componentsProps={{typography: {fontSize: 14}}}
                                                                                    label={
                                                                                        <Typography
                                                                                            sx={{fontSize: 13}}>Edit</Typography>
                                                                                    }
                                                                                />
                                                                            )}
                                                                        />
                                                                    </>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                            })}
                        </Box>
                        <Stack direction="row">
                            <Button
                                variant="contained"
                                onClick={handleSubmit(handleSubmitTeammateInvitation)}
                                sx={{mr: 1, fontSize: 13, fontWeight: 500}}
                            >
                                Submit
                            </Button>
                            <Box>
                                <Button
                                    variant="text"
                                    onClick={close}
                                    sx={{fontSize: 13, fontWeight: 500}}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Stack>
                    </>
                ) : (
                    <>
                        <Box sx={{mb: 2}}>
                            <Typography fontSize={13} fontWeight={700}>
                                Members
                            </Typography>
                            <Typography fontSize={13}>
                                Invite members to access all or specific services on your account
                            </Typography>
                        </Box>
                        <Box sx={{mb: 3}}>
                            <TextField
                                ref={input}
                                fullWidth
                                size="small"
                                type="text"
                                label="Separate multiple email addresses with commas"
                                InputLabelProps={{sx: {fontSize: "13px"}}}
                                inputProps={{
                                    sx: {fontSize: 13, bgcolor: "white", borderRadius: 0},
                                }}
                                sx={{
                                    mb: 1,
                                    ".MuiInputBase-root": {borderRadius: 0},
                                    ".MuiInputLabel-shrink": {transform: "translate(14px, -9px)"},
                                }}
                                onKeyDown={(event: any) =>
                                    event.keyCode === 13 && handleSubmitMembers()
                                }
                            />
                            <Button
                                variant="contained"
                                onClick={handleSubmitMembers}
                                sx={{mr: 1, fontSize: 13, fontWeight: 500}}
                            >
                                Add
                            </Button>
                            {members.length === 0 && (
                                <Button
                                    variant="text"
                                    onClick={close}
                                    sx={{fontSize: 13, fontWeight: 500}}
                                >
                                    Close
                                </Button>
                            )}
                        </Box>
                        {members.length !== 0 && (
                            <Box component="form">
                                <Box sx={{mb: 3}}>
                                    <Box sx={{mb: 2}}>
                                        <Typography fontSize={13} fontWeight={700}>
                                            Scope
                                        </Typography>
                                        <Typography fontSize={13}>
                                            Choose the scope you want to apply for invited members.
                                        </Typography>
                                    </Box>
                                    <Box sx={{mb: 2}}>
                                        <Box sx={{mb: 2}}>
                                            {members?.map((item: string, index: number) => (
                                                <Chip
                                                    key={index}
                                                    label={item}
                                                    deleteIcon={<CloseOutlinedIcon/>}
                                                    sx={{
                                                        borderRadius: 0,
                                                        bgcolor: "transparent",
                                                        border: `1px solid black`,
                                                        mb: 0.5,
                                                    }}
                                                    onDelete={() => handleRemoveMember(item)}
                                                />
                                            ))}
                                        </Box>
                                        <React.Suspense fallback={<LoadingDotBox/>}>
                                            <Grid container sx={{mb: 1}}>
                                                <Grid item sm={12}>
                                                    <Box sx={{mb: 1}}>
                                                        <Typography fontSize={12} fontWeight={700} sx={{mb: 0.5}}>
                                                            Operator
                                                        </Typography>
                                                        <Controller
                                                            control={control}
                                                            name={"operator"}
                                                            defaultValue="include"
                                                            render={({field}) => (
                                                                <FormControl fullWidth>
                                                                    <Select
                                                                        size="small"
                                                                        inputProps={selectInputProps}
                                                                        {...field}
                                                                    >
                                                                        <MenuItem value="include">
                                                                            <Typography
                                                                                fontSize={12}>Include</Typography>
                                                                        </MenuItem>
                                                                        <MenuItem value="exclude">
                                                                            <Typography
                                                                                fontSize={12}>Exclude</Typography>
                                                                        </MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item sm={12}>
                                                    <Box sx={{mb: 1}}>
                                                        <Typography fontSize={12} fontWeight={700} sx={{mb: 0.5}}>
                                                            Resource
                                                        </Typography>
                                                        <Controller
                                                            control={control}
                                                            name={"share_referrer_type"}
                                                            defaultValue="service"
                                                            render={({field: {onChange, ...field}}) => (
                                                                <FormControl fullWidth>
                                                                    <Select
                                                                        size="small"
                                                                        inputProps={selectInputProps}
                                                                        onChange={(event: any) => onChange(event.target.value)}
                                                                        {...field}
                                                                    >
                                                                        {resources?.map((item: any) => {
                                                                            return (
                                                                                <MenuItem key={item.name}
                                                                                          disabled={item.disabled}
                                                                                          value={item.value}>
                                                                                    <Typography
                                                                                        fontSize={12}>{item.name}</Typography>
                                                                                </MenuItem>
                                                                            )
                                                                        })}
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item sm={12}>
                                                    <Box>
                                                        <Typography fontSize={12} fontWeight={700} sx={{mb: 0.5}}>
                                                            Objects
                                                        </Typography>
                                                        <Controller
                                                            control={control}
                                                            name={"share_referrer_objects"}
                                                            defaultValue={['-']}
                                                            render={({field}) => (
                                                                <FormControl fullWidth>
                                                                    <Select
                                                                        {...field}
                                                                        size="small"
                                                                        multiple
                                                                        inputProps={selectInputProps}
                                                                        renderValue={(selected) => {
                                                                            const selects = all.concat(services).filter((item: any) => selected.includes(item.service_id))

                                                                            return (
                                                                                <Box sx={{
                                                                                    display: 'flex',
                                                                                    flexWrap: 'wrap',
                                                                                    gap: 0.5
                                                                                }}>
                                                                                    {selects.map((item: any) => (
                                                                                        <Chip size="small"
                                                                                              key={item.service_id}
                                                                                              label={item.service_name}/>
                                                                                    ))}
                                                                                </Box>
                                                                            )
                                                                        }}
                                                                        sx={{
                                                                            ".MuiSelect-multiple": {
                                                                                // bgcolor: 'red',
                                                                                px: 1,
                                                                                py: 0.75
                                                                            }
                                                                        }}
                                                                    >
                                                                        <MenuItem value="-">
                                                                            <Typography
                                                                                fontSize={12}>All</Typography>
                                                                        </MenuItem>
                                                                        {services?.map((service: Service) => {
                                                                            return (
                                                                                <MenuItem key={service.service_id}
                                                                                          value={service.service_id}>
                                                                                    <Typography fontSize={12}>
                                                                                        {service.service_name}
                                                                                    </Typography>
                                                                                </MenuItem>
                                                                            );
                                                                        })}
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </React.Suspense>
                                    </Box>
                                </Box>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit(handleScopePreview)}
                                    sx={{mr: 1, fontSize: 13, fontWeight: 500}}
                                >
                                    Next
                                </Button>
                                <Button
                                    variant="text"
                                    onClick={close}
                                    sx={{fontSize: 13, fontWeight: 500}}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </Utils.LayoutUtils.MainAttachedSidebar>
    );
}
